import { useCallback, useEffect, useState } from 'react';
export default function useCEOManagementData(loadManagement) {
  const [reload, setReload] = useState(0);
  const [state, setState] = useState({ data: null, pending: false, error: '' });
  const refresh = useCallback(() => setReload((value) => value + 1), []);
  useEffect(() => {
    if (!loadManagement) { setState({ data: null, pending: false, error: '' }); return undefined; }
    const controller = new AbortController();
    setState((current) => ({ ...current, pending: true, error: '' }));
    Promise.resolve().then(() => loadManagement({ signal: controller.signal })).then((data) => {
      if (!controller.signal.aborted) setState({ data: data || null, pending: false, error: '' });
    }).catch((error) => {
      if (!controller.signal.aborted) setState({ data: null, pending: false, error: error?.message || 'Unable to load organization data.' });
    });
    return () => controller.abort();
  }, [loadManagement, reload]);
  return { ...state, refresh };
}
